import { CommonAPIService } from '@/servicehandlers/CommonHandler';

export class DeviceAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  // Blocked Domains
  getBlockedSites(router, store) {
    const url = `/api/devices/pr/network/blocked_domains`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  getDeviceGateway(router, store) {
    const url = `/api/devices/pr/network/dhcpgateway`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postBlockedSites(data, router, store) { // {"domain": "www.greathair.com"}
    const url = `/api/devices/pr/network/block_domain`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  deleteBlockedSites(data, router, store) { // {"domain": "www.greathair.com"}
    const url = `/api/devices/pr/network/block_domain`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }
 
  // Blocked IP / Netword
  getBlockedIPs(router, store) {
    const url = `/api/devices/pr/network/blocked_ips`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postBlockedIPs(data, router, store) { // {"ip": "10.4.8.0/24", "description":"Nate's Cat Memes"}
    const url = `/api/devices/pr/network/block_ip`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  deleteBlockedIPs(data, router, store) { // {"ip": "10.4.5.6"}
    const url = `/api/devices/pr/network/block_ip`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }

  // Bulk Rules
  getBulkRules(router, store) {
    const url = `/api/devices/pr/network/rules/bulkrules`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postBulkRules(data, router, store) { // {"list": "porn_domains", "status": "enabled"}
    const url = `/api/devices/pr/network/rules/bulkblock`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  deleteBulkRules(data, router, store) { // {"list": "porn_domains", "status": "disabled"}
    const url = `/api/devices/pr/network/rules/bulkdelete`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }

  getRules(router, store) {
    const url = `/api/devices/pr/network/rules`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postRules(data, router, store) { // {"list": "porn_domains", "status": "enabled"}
    const url = `/api/devices/pr/network/rules/bulk`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  // Schedule Rules
  getScheduleRules(router, store) {
    const url = `/api/devices/pr/scheduled_rules`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postScheduleRules(data, router, store) { // {"list": "porn_domains", "status": "enabled"}
    const url = `/api/devices/pr/scheduled_rules`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  putScheduleRules(id, data, router, store) {
    const url = `/api/devices/pr/scheduled_rules/${id}`;
    return this.CommonAPIService.putCall(url, data, router, store);
  }

  deleteScheduleRules(id, router, store) {
    const url = `/api/devices/pr/scheduled_rules/${encodeURIComponent(id)}`;
    return this.CommonAPIService.deleteCall(url, {}, router, store);
  }

  // Devices (Missing 1 put, 2 post)
  getDevices(router, store) {
    const url = `/api/devices/pr/devices`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  getDeviceBlockStatus(router, store) {
    const url = `/api/devices/pr/devices/block_status`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postBlockInternetDevice(data, router, store) {
    const url = '/api/devices/pr/devices/block_internet';
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  postUnblockInternetDevice(data, router, store) {
    const url = '/api/devices/pr/devices/unblock_internet';
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  putRenameDevice(mac, data, router, store) { // e.g. data = { newName: 'Bob’s iPhone' }
    const url = `/api/devices/pr/devices/${encodeURIComponent(mac)}`;
    return this.CommonAPIService.putCall(url, data, router, store);
  }

  // Port Forwarding
  getPortForwarding(router, store) {
    const url = `/api/devices/pr/forwarders`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postPortForwarding(data, router, store) {
    const url = `/api/devices/pr/forwarders`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  updatePortForwarding(data, router, store) {
    const url = `/api/devices/pr/forwarders`;
    return this.CommonAPIService.putCall(url, data, router, store);
  }

  deletePortForwarding(data, router, store) {
    const url = `/api/devices/pr/forwarders`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }

  // Block Port Forwarding 
  getBlockedPortForwards(router, store) {
    const url = `/api/devices/pr/network/port_forwards`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  postBlockedPortForwards(data, router, store) {
    const url = `/api/devices/pr/network/block_port_forward`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  deleteBlockedPortForwards(data, router, store) {
    const url = `/api/devices/pr/network/rules/block_port_forward`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }

  // Groups
  getGroups(router, store) {
    const url = `/api/devices/pr/groups`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  createGroup(data, router, store) {
    const url = `/api/devices/pr/groups`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }

  updateGroup(data, router, store) {
    const url = `/api/devices/pr/groups`;
    return this.CommonAPIService.putCall(url, data, router, store);
  }

  deleteGroup(data, router, store) {
    const url = `/api/devices/pr/groups`;
    return this.CommonAPIService.deleteCall(url, data, router, store);
  }

  // Metric 
  networkMetrics(router, store) {
    const url = `/api/devices/pr/metrics`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }
  networkHealth(router, store) {
    const url = `/api/devices/pr/metrics/packet_loss`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }

  performSpeedTest(router, store){
    const url = `/api/devices/pr/network/speed_test`
    return this.CommonAPIService.getCall(url, '', router, store)
  }
  aiCall(data, router, store) {
    const url = `/api/devices/pr/ai`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }
  getSerialNumber(router, store) {
    const url = `/api/devices/pr/settings/serialNumber`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }
  getVersionNumber(router, store) {
    const url = `/api/devices/pr/settings/versionNumber`;
    return this.CommonAPIService.getCall(url, '', router, store);
  }
  updateDevice(data, router, store) {
    const url = `/api/devices/pr/settings/update`;
    return this.CommonAPIService.postCall(url, data, router, store);
  }
  updateStatus(data, router, store) {
    const url = `/api/devices/pr/settings/update`;
    return this.CommonAPIService.getCall(url, data, router, store);
  }

  getCurrentReleaseVersion(router, store){
    const url = `/api/metadata`
    return this.CommonAPIService.getCall(url, '', router, store)
  }

  getDeviceTrackingData(router, store){
    const url = `/api/devices/pr/tracking`
    return this.CommonAPIService.getCall(url, '', router, store)
  }

  getDailyDomainLimits(router, store){
    const url = `/api/devices/pr/domains`
    return this.CommonAPIService.getCall(url, '', router, store)
  }

  createDomainLimitOnDevice(data, router, store){
    const url = `/api/devices/pr/domains`
    return this.CommonAPIService.postCall(url, data, router, store)
  }

  deleteDomainLimitOnDevice(data, router, store){
    const url = `/api/devices/pr/domains`
    return this.CommonAPIService.deleteCall(url, data, router, store)
  }
}
export default DeviceAPIService;

